import React from 'react';

import './SectionInfo.css';

const SectionInfo = (props) => {
    
    return (
        <section className="SectionInfo__main-section-container">
            <div className="SectionInfo__title-container" style={{ backgroundColor: `${props.color}`, borderRadius :`${props.borderStyle}`, margin :`${props.marginStyle}` } }>
                <h4 className="SectionInfo__title" >{props.title}</h4>
            </div>
        </section>
    );
} 
export default SectionInfo;